import React from "react";
import BloodRelations from "@features/port-security/components/social-info/BloodRelations";
import Children from "@features/port-security/components/social-info/Children";
import FirstGradeRelations from "@features/port-security/components/social-info/FirstGradeRelations";
import Friends from "@features/port-security/components/social-info/Friends";
import Residence from "@features/port-security/components/social-info/Residence";
import SocialStatus from "@features/port-security/components/social-info/SocialStatus";

const SocialInfoForm: React.FC = () => {
  return (
    <div data-testid="social-info-form" className="flex flex-col gap-8">
      <SocialStatus />
      <Children />
      <FirstGradeRelations />
      <BloodRelations />
      <Friends />
      <Residence />
    </div>
  );
};

export default SocialInfoForm;
